<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">
                                            
                                            <div class="row">
                                                <div class="col-md-12 col-xl-12">
                                                    <div class="card summery-card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Processes</h5>
                                                            </div>
                                                            <div v-if="$checkPerm('process.create')" class="card-header-right">
                                                                <button data-toggle="modal" data-target="#addProcess" class="btn btn-primary btn-md">New Process</button>
                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card">
                                                            <div class="table-responsive">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>ID</th>
                                                                            <th>Process Name</th>
                                                                            <th>Description</th>
                                                                            <!-- <th>Action</th> -->
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(process, index) in processes">
                                                                            <td>{{index + 1}}</td>
                                                                            <td>{{process.process_name}}</td>
                                                                            <td>{{process.description}}</td>
                                                                            <!-- <td>
                                                                                <button title="Not Implemented" class="btn btn-primary btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</button>
                                                                            </td> -->
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="$checkPerm('process.create')" id="addProcess" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Add Process.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="createProcess">
                            <div class="form-group">
                                <label>Process Name:</label>
                                <input type="text" class="form-control" name="process_name" placeholder="Process Name" v-model="new_process.process_name" required="required" />
                            </div>
                            <div class="form-group">
                                <label>Process Description:</label>
                                <textarea class="form-control" placeholder="Process Description" maxlength="300" v-model="new_process.description"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-primary form-control">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <Tips message='This is the "Stages" view, from here you can manage stages and processes. You can add stages, create processes and associate stages with processes.' />
    </div>
</template>
<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active{
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {background-color: #00ff00;}

</style>

<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'
import Tips from '../components/Tips.vue'

export default {
    name: 'Stages',

    data(){
        return{
            stages: [],
            processes: [
                {
                    id: "Loading..."
                }
            ],
            new_stage: {

            },
            new_process: {
                process_name: '',
                description: ''
            }
        }
    },

    components:{
        navbar1,
        navbar2,
        Tips
    },

    mounted(){
        this.getStages()
        this.getProcesses()
    },
    methods: {

        getOpening(id){

            var get_openings_request = {
                what: 'ListApplicants',
                id: id
            }

            this.$socket.makeGetRequest(get_openings_request)
                .then((response)=>{
                    if(response.type == 'ListApplicants'){
                        this.opening_rows = response.data
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        },

        getStages(){
            var stages = {
                what: 'GetStages'
            }

            this.$socket.makeGetRequest(stages)
                .then((response)=>{
                    //console.log(response)
                })
                .catch((error)=>{
                    //console.log(error)
                })
        },

        getProcesses(){
            var stages = {
                what: 'GetProcesses'
            }

            this.$socket.makeGetRequest(stages)
                .then((response)=>{
                    if(response.type == 'GetProcesses'){
                        this.processes = response.data
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
        },

        createStage(){

        },

        createProcess(){
            var create = {
                what: 'CreateProcess',
                data: this.new_process
            }

            console.log(create)

            this.$socket.makePostRequest(create)
                .then((response)=>{
                    if(response.type == 'CreateProcess' && response.status == "true"){
                        window.alert("Process created!")

                        setTimeout(()=>{
                            window.location.reload()
                        }, 1000)
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
        },

        refresh(){

        }
    },
    computed: {
        
    }
}
</script>
